import Reveal from "@/components/base/Reveal";
import SectionLabel from "@/components/base/SectionLabel";

export default function Contact() {
  return (
    <section id="contato" className="relative bg-background-50 py-16 md:py-20 lg:py-24">
      <span
        className="pointer-events-none absolute inset-x-0 top-0 mx-auto h-px w-2/3 bg-gradient-to-r from-transparent via-accent-500/25 to-transparent"
        aria-hidden="true"
      />
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <SectionLabel>Contato</SectionLabel>
            <h2 className="mt-5 font-heading text-3xl font-medium leading-[1.15] text-foreground-950 md:text-5xl">
              Fale com o comercial
            </h2>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
              Para informações sobre produtos, disponibilidade e condições comerciais, entre em contato com nossa
              equipe — retornaremos pelo e-mail informado.
            </p>
          </Reveal>

          <Reveal delay={120}>
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-9">
              <p className="ocean-label text-xs text-foreground-500 md:text-[10px]">E-mail comercial</p>
              <a
                href="mailto:comercial@oceancompanhia.com.br"
                className="mt-3 block whitespace-nowrap font-heading text-lg leading-tight text-foreground-950 transition-colors duration-300 hover:text-accent-600 md:text-[clamp(1rem,2.4vw,1.6rem)]"
              >
                comercial@oceancompanhia.com.br
              </a>

              <div className="mt-8 border-t border-background-200 pt-8">
                <a
                  href="mailto:comercial@oceancompanhia.com.br"
                  className="inline-flex w-full cursor-pointer items-center justify-center gap-2.5 rounded-md bg-accent-500 px-6 py-4 text-lg font-medium text-primary-950 transition-colors duration-300 hover:bg-accent-400 sm:w-auto"
                >
                  <i className="ri-mail-line text-xl"></i>
                  Enviar e-mail
                </a>
                <p className="mt-4 text-sm leading-relaxed text-foreground-500">
                  Sua mensagem será enviada diretamente para a equipe da Ocean.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}